import ContainerPage from "../../components/ContainerPage/ContainerPage"
import PageTitle from "../../components/PageTitle/PageTitle"
import React, { useState } from "react"
import Tab from "../../components/Tab/Tab"
import { LuUser } from "react-icons/lu"
import { useNavigate } from "react-router-dom"
import UserGeneralTab from "../../components/EditUserGeneral/EditUserGeneral"


const EditUserPage = ({ viewOnly = false, successNavTo = false, cancelNavTo = false }) => {
  const navigate = useNavigate()
  const [activeTab, setActiveTab] = useState('general')

  const handleTabChange = (tab) => {
    setActiveTab(tab)
  }

  return (
    <ContainerPage>
      <PageTitle title="Account" onBack={() => navigate(-1)} />
      <div className="mt-8">
        <div className="flex gap-10 mb-8 border-b border-divider">
          <Tab imgLink={<LuUser size={18} color={activeTab === "general" ? 'var(--color-primary-main)' : 'var(--color-gray-600)'} />}
            isActive={activeTab === "general"} onClick={() => handleTabChange('general')}>
            General
          </Tab>
        </div>
        <div className="flex items-start justify-center">
          {activeTab === 'general' && <UserGeneralTab assigneesAllowed={true} viewOnly={viewOnly} successNavTo={successNavTo} cancelNavTo={cancelNavTo} />}
        </div>
      </div>
    </ContainerPage>
  )
}

export default EditUserPage